module.exports = __webpack_public_path__ + "media/components/documents/images/taxReturnForms/1120-ef6ca1dec5d40736bb829c7718932319.png";